import berufChanceIcon from "../assets/Beruf-und-Chance.svg";
import besserLebenIcon from "../assets/Besser-Leben.svg";
import essenTrinkenIcon from "../assets/Essen-und-Trinken.svg";
import fplusIcon from "../assets/F-Plus.svg";
import fruehdenkerIcon from "../assets/Fruehdenker.svg";
import gesundheitIcon from "../assets/Gesundheit.svg";
import hauptwacheIcon from "../assets/Hauptwache.svg";
import immobilienIcon from "../assets/Immobilien.svg";
import kritikIcon from "../assets/Kritik.svg";
import literaturIcon from "../assets/Literatur.svg";
import meinungIcon from "../assets/Meinung.svg";
import newsQuizIcon from "../assets/News-Quiz.svg";
import politikIcon from "../assets/Politik.svg";
import digitalwirtschaftIcon from "../assets/Premium-Digitalwirtschaft.svg";
import einspruchIcon from "../assets/Premium-Einspruch.svg";
import meineFinanzenIcon from "../assets/Premium-Meine-Finanzen.svg";
import weltwirtschaftIcon from "../assets/Premium-Weltwirtschaft.svg";
import sportIcon from "../assets/Sport.svg";
import stilIcon from "../assets/Stil.svg";
import technikMotorIcon from "../assets/Technik-und-Motor.svg";
import themenAbendIcon from "../assets/Themen-am-Abend.svg";
import themenMittagIcon from "../assets/Themen-am-Mittag.svg";
import themenMorgenIcon from "../assets/Themen-am-Morgen.svg";
import wirtschaftIcon from "../assets/Wirtschaft.svg";
import wissenIcon from "../assets/Wissen.svg";

export const newsletters = [
  {
    id: "fruehdenker",
    label: "Frühdenker",
    url: "https://nl.faz.net/#fruehdenker",
    icon: fruehdenkerIcon,
  },
  {
    id: "fplus",
    label: "FAZ+",
    url: "https://nl.faz.net/#fplus",
    icon: fplusIcon,
  },
  {
    id: "digitalwirtschaft",
    label: "Digital-<br/>wirtschaft",
    url: "https://nl.faz.net/#digitalwirtschaft",
    icon: digitalwirtschaftIcon,
  },
  {
    id: "weltwirtschaft",
    label: "Welt-<br>wirtschaft",
    url: "https://nl.faz.net/#weltwirtschaft",
    icon: weltwirtschaftIcon,
  },
  {
    id: "einspruch",
    label: "Einspruch",
    url: "https://nl.faz.net/#einspruch",
    icon: einspruchIcon,
  },
  {
    id: "meinefinanzen",
    label: "Meine Finanzen",
    url: "https://nl.faz.net/#finanzenPRO",
    icon: meineFinanzenIcon,
  },
  {
    id: "hauptwache",
    label: "Hauptwache",
    url: "https://nl.faz.net/#hauptwache",
    icon: hauptwacheIcon,
  },
  {
    id: "meinung",
    label: "Meinung",
    url: "https://nl.faz.net/#meinung",
    icon: meinungIcon,
  },
  {
    id: "der-tag-am-morgen",
    label: "Der Tag am Morgen",
    url: "https://nl.faz.net/#der-tag-am-morgen",
    icon: themenMorgenIcon,
  },
  {
    id: "der-tag-am-mittag",
    label: "Der Tag am Mittag",
    url: "https://nl.faz.net/#der-tag-am-mittag",
    icon: themenMittagIcon,
  },
  {
    id: "der-tag-am-abend",
    label: "Der Tag am Abend",
    url: "https://nl.faz.net/#der-tag-am-abend",
    icon: themenAbendIcon,
  },
  {
    id: "beruf-chance",
    label: "Beruf und Chance",
    url: "https://nl.faz.net/#beruf",
    icon: berufChanceIcon,
  },
  {
    id: "besser-leben",
    label: "Besser Leben",
    url: "https://nl.faz.net/#besserLeben",
    icon: besserLebenIcon,
  },
  {
    id: "essen-trinken",
    label: "Essen und Trinken",
    url: "https://nl.faz.net/#essenUndTrinken",
    icon: essenTrinkenIcon,
  },
  {
    id: "gesundheit",
    label: "Gesundheit",
    url: "https://nl.faz.net/#gesundheit",
    icon: gesundheitIcon,
  },
  {
    id: "immobilien",
    label: "Immobilien",
    url: "https://nl.faz.net/#immobilien",
    icon: immobilienIcon,
  },
  {
    id: "kritik",
    label: "Kritik",
    url: "https://nl.faz.net/#kritik",
    icon: kritikIcon,
  },
  {
    id: "literatur",
    label: "Literatur",
    url: "https://nl.faz.net/#kritik",
    icon: literaturIcon,
  },
  {
    id: "news-quiz",
    label: "News Quiz",
    url: "https://nl.faz.net/#newsquiz",
    icon: newsQuizIcon,
  },
  {
    id: "politik",
    label: "Politik",
    url: "https://nl.faz.net/#politik",
    icon: politikIcon,
  },
  {
    id: "sport",
    label: "Sport",
    url: "https://nl.faz.net/#sport",
    icon: sportIcon,
  },
  {
    id: "stil",
    label: "Stil",
    url: "https://nl.faz.net/#stil",
    icon: stilIcon,
  },
  {
    id: "technik-motor",
    label: "Technik und <br> Motor",
    url: "https://nl.faz.net/#technikUndMotor",
    icon: technikMotorIcon,
  },
  {
    id: "wirtschaft",
    label: "Wirtschaft",
    url: "https://nl.faz.net/#wirtschaft",
    icon: wirtschaftIcon,
  },
  {
    id: "wissen",
    label: "Wissen",
    url: "https://nl.faz.net/#wissen",
    icon: wissenIcon,
  },
];
